import React, { useMemo } from 'react';
import Favicon from 'react-favicon';
import { LocalizeProvider, Translate, withLocalize } from 'react-localize-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Footer from './components/common/Footer/Footer';
import Loader from './components/common/Loader/Loader';
import NavBarPrivate from './components/common/NavBar/NavBarPrivate';
import NavBarPublic from './components/common/NavBar/NavBarPublic';
import ReauthModal from './components/common/ReauthModal/ReauthModal';
import GoogleAnalytics from './components/common/GoogleAnalytics/GoogleAnalytics';
import Routes from './components/common/Routes/Routes';
import TokenInfo from './components/common/TokenInfo/TokenInfo';
import syncAuth from './Hoc/Authentication/SyncAuth';
import { useHasSession } from './Hooks/useHasSession';
import { persistor, store } from './store/store';
import defaultLanguages from './utils/helpers/defaultLanguage';

import './assets/styles/layout.css';

// Check if debug mode is enabled
const isDebugMode = () => process.env.REACT_APP_SHOW_TOKEN_INFO === 'true';

function TempEdge() {
  const { languages, options } = defaultLanguages();
  const hasSession = useHasSession();

  const footerContent = useMemo(
    () => (
      <p>
        © <Translate id="com.tempedge.msg.label.footer" /> <Translate id="com.tempedge.msg.label.rights" />
      </p>
    ),
    []
  );

  return (
    <PersistGate loading={<Loader />} persistor={persistor}>
      <LocalizeProvider store={store} initialize={{ languages, options }}>
        <Favicon url="/img/favicon.ico" />
        <div className="app-shell">
          <div className="contents">
            <GoogleAnalytics />
            {hasSession ? <NavBarPrivate /> : <NavBarPublic />}
            {hasSession && <ReauthModal />}
            <Routes />
          </div>
          <Footer content={footerContent} />
        </div>

        {isDebugMode() && <TokenInfo />}
      </LocalizeProvider>
    </PersistGate>
  );
}

export default withLocalize(syncAuth(TempEdge));
